import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'iconUrl'})
export class IconUrlPipe implements PipeTransform {
  transform(iconNumber: string): string {
    return 'i-w[icon]'.replace('[icon]', iconNumber);
  }
}
